import type { IExercise } from '../exercises';

export const FANJUE_EPISODE_12_MATERIALS: IExercise[] = [
  {
    "id": "course-20261008-fanjue-plan-12-01",
    "name": "肩部热身",
    "bodyPart": "warmup",
    "equipment": "bodyweight",
    "subCategory": "shoulder",
    "tips": ["肩部环绕激活肩袖肌群", "前后各10圈"],
    "sets": 2,
    "reps": "15次",
    "rpe": 5,
    "restSeconds": 30,
    "isBodyweight": true,
    "isWarmup": true,
    "demoUrl": "/media/collections-20261008/demos/66ae35049df9146e7306a50c.mp4",
    "videoUrl": "/media/collections-20261008/videos/cb8dad2797a438dc5e228602.mp4",
    "targetMuscles": ["全身激活肌群"],
    "difficulty": "beginner",
    "source": "焚诀计划 · 第12期",
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-fanjue-plan-12-02",
    "name": "史密斯推肩",
    "bodyPart": "shoulders",
    "equipment": "machine",
    "subCategory": "front-deltoid",
    "tips": ["史密斯轨迹稳定", "推至头顶不锁肘"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "demoUrl": "/media/collections-20261008/demos/reviewed-b8c0f6cedd4f528b5ef0f5d5.mp4",
    "videoUrl": "/media/collections-20261008/videos/facbfc418edc448bf4dcd766.mp4",
    "targetMuscles": ["三角肌前束", "三角肌中束"],
    "difficulty": "beginner",
    "source": "焚诀计划 · 第12期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-fanjue-plan-12-03",
    "name": "哑铃侧平举",
    "bodyPart": "shoulders",
    "equipment": "dumbbell",
    "subCategory": "medial-delt",
    "tips": ["肘微屈，侧抬与肩齐平", "控制下放"],
    "sets": 3,
    "reps": "15",
    "rpe": 7,
    "restSeconds": 45,
    "isBodyweight": false,
    "source": "焚诀计划 · 第12期",
    "demoUrl": "/media/collections-20261008/demos/reviewed-3430e586644879373ef15d80.mp4",
    "videoUrl": "/media/collections-20261008/videos/9135c3d74a4f8e565f774a81.mp4",
    "targetMuscles": ["三角肌中束"],
    "difficulty": "intermediate",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-fanjue-plan-12-04",
    "name": "哑铃前平举",
    "bodyPart": "shoulders",
    "equipment": "dumbbell",
    "subCategory": "front-deltoid",
    "tips": ["前平举刺激前束", "交替或双手"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 45,
    "isBodyweight": false,
    "demoUrl": "/media/collections-20261008/demos/reviewed-6c1bfe4fb2d23faa7a347240.mp4",
    "videoUrl": "/media/collections-20261008/videos/reviewed-a383efba9ee0260d0d5171b5.mp4",
    "targetMuscles": ["三角肌前束"],
    "difficulty": "intermediate",
    "source": "焚诀计划 · 第12期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-fanjue-plan-12-05",
    "name": "绳索面拉",
    "bodyPart": "shoulders",
    "equipment": "cable",
    "subCategory": "rear-deltoid",
    "tips": ["仰卧训练凳完成绳索面拉", "按教学保持肘部路径并控制回放"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["三角肌后束", "肩袖肌群"],
    "demoUrl": "/media/collections-20261008/demos/reviewed-6f8000024925cb2b4c57ea75.mp4",
    "videoUrl": "/media/collections-20261008/videos/reviewed-4409a3f92fab37757d2e1fa8.mp4",
    "source": "焚诀计划 · 第12期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-fanjue-plan-12-06",
    "name": "侧平举",
    "bodyPart": "shoulders",
    "equipment": "dumbbell",
    "subCategory": "medial-delt",
    "tips": ["肘微屈，侧抬与肩齐平", "控制下放"],
    "sets": 3,
    "reps": "15",
    "rpe": 7,
    "restSeconds": 45,
    "isBodyweight": false,
    "source": "焚诀计划 · 第12期",
    "demoUrl": "/media/collections-20261008/demos/reviewed-08491bd27be01b1f7b28d114.mp4",
    "videoUrl": "/media/collections-20261008/videos/c348b9bdffaf6eb7f425c2b3.mp4",
    "targetMuscles": ["三角肌中束"],
    "difficulty": "intermediate",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
];
